import React, { useContext, useEffect, useState } from 'react'
import './object-detail.less'
import { SystemContext } from '@/App';
import { SystemStatus } from '@/commons/context/system-store';
import { ObjectDetail } from '@/commons/interface/object-detail';
import { getGroupsByBuildingUuid } from '@/api/spec-common/group';
import { useParams } from 'react-router-dom';
import { Group } from '@/commons/interface/speccommon/group';
import { GroupType } from 'tnbimbase';
import { Radio } from 'antd';
import classNames from 'classnames';
import ObjectDetailBasicPanel from './object-detail-basic';
import ObjectDetailFilePanel from './object-detail-file';
import ObjectDetailRecordPanel from './object-detail-record';

const ActiveTabType = {
    BASIC: 1,
    FILE: 2,
    RECORD: 3,
}

export default function ObjectDetailPanel() {
    const { projectUuid, buildingUuid } = useParams();
    const systemContext = useContext<SystemStatus>(SystemContext);
    const [groups, setGroups] = useState<Group[]>([]) // 全局的分组
    const [detail, setDetail] = useState<ObjectDetail>({}); // 当前展示的详情
    const [activeTab, setActiveTab] = useState<number>(ActiveTabType.BASIC);

    useEffect(() => {
        getGroupsByBuildingUuid(projectUuid, buildingUuid).then(res => {
            let data: Group[] = res.data || [];
            data = data?.map(item => {
                item.hidden = true;
                return item;
            })
            setGroups(data);
        })
    }, [buildingUuid])

    const buildPath = (groupIds: string[]) => {
        if (groups?.length === 0) return [];
        let groupMap: { [key: string]: Group } = {};
        // let tree: (Group & { level?: number })[] = [];
        // 构建dict
        groups?.forEach(group => {
            groupMap[group?.uuid] = { ...group, children: [], level: 1 };
        });
        let tree = [];
        // 构建树
        groupIds.forEach(uuid => {
            let group = groupMap[uuid];
            if (group == null) return;
            if (tree.find(item => item.uuid == group.uuid)) return;
            searchParent(group, groupMap, tree);
        })

        // groups.forEach(group => {
        //     const parent = groupMap[group?.parentUuid];
        //     if (parent) {
        //         parent?.children.push(groupMap[group?.uuid]);
        //         groupMap[group?.uuid].level = (parent?.level || 1) + 1;
        //     } else {
        //         tree.push(groupMap[group?.uuid]);
        //     }
        // });

        return tree;
    };

    const searchParent = (group: Group, groupMap: { [key: string]: Group }, tree: Group[]) => {
        const parent = groupMap[group?.parentUuid];
        if (parent) {
            searchParent(parent, groupMap, tree);
        }
        tree.push(group);
    }

    useEffect(() => {
        if (!systemContext.currentSelectedEntity) {
            return;
        }
        let res: ObjectDetail = {};
        let entity = systemContext.currentSelectedEntity;
        console.log(entity.type);
        let tree = buildPath(entity.group[GroupType.GROUP] || []);

        res.status = "正常";
        res.uuid = entity.uuid;

        if (entity.type === "ColumnT") {
            // 柱子
            res.name = "立柱";
            res.function = "竖向传力构件";
            res.makeups = [
                { name: '钢骨', mat: '钢' },
                { name: '钢筋', mat: '钢' },
                { name: '瓷砖', mat: '大理石' },
            ]
            res.size = "500*500*3600(mm)"
            res.materials = [
                { name: '钢', type: 'Q355' },
            ]
        } else if (entity.opacity < 1) {
            // 玻璃
            res.name = "玻璃隔断";
            res.function = "维护构件，用于分隔空间";
            res.makeups = [
                { name: '玻璃面板', mat: '玻璃' },
                { name: '支托', mat: '不锈钢' },
                { name: '拉索', mat: '高强钢' },
            ]
            res.size = "500*20*500(mm)"
            res.materials = [
                { name: '玻璃', type: '12T' },
            ]
        } else if (entity.type === "FireHydrantT") {
            // 消火栓
            res.name = "消火栓";
            res.function = "在火灾发生时排除危险，确保人员的安全";
            res.makeups = [
                { name: '箱柜', mat: '不锈钢' },
                { name: '皮管', mat: '特种橡胶' },
                { name: '接头', mat: '铝' },
            ]
            res.size = "1200*1400*800(mm)"
            res.materials = [
                { name: '不锈钢', type: '304' },
                { name: '铝', type: '2A01' },
            ]
        } else if (entity.type === "TunnelT") {
            // 管道
            res.name = "消防管道";
            res.function = "消防供水";
            res.makeups = [
                { name: '水管', mat: '不锈钢' },
                { name: '接头', mat: '铝' },
            ]
            res.size = "φ50*8000(mm)"
            res.materials = [
                { name: '不锈钢', type: '304' },
                { name: '铝', type: '2A01' },
            ]
        } else if (entity.type === "SprayHeadT") {
            // 烟感器
            res.name = "烟感器";
            res.function = "感应到火灾烟雾时自动洒水灭火";
            res.makeups = [
                { name: '保险丝', mat: '银铜合金' },
                { name: '烟感传感器', mat: '' },
            ]
            res.size = "100*100*100(mm)"
            res.materials = [
                { name: '银铜合金', type: '' },
            ]
        } else if (entity.type === "FireExtinguisherT") {
            // 灭火器
            res.name = "灭火器";
            res.function = "手持式灭火设备";
            res.makeups = [
                { name: '喷头', mat: '不锈钢' },
                { name: '瓶身', mat: '不锈钢' },
            ]
            res.size = "φ100*300(mm)"
            res.materials = [
                { name: '不锈钢', type: '304' },
            ]
        }

        tree.push({
            uuid: entity.uuid,
            name: res.name
        })
        res.groups = tree;
        setDetail(res);
    }, [systemContext.currentSelectedEntity])

    return (
        <div className='object-detail-container'>
            <div className='title'>详情</div>
            <div className='description-item'>
                <div className='name'>对象</div>
                <div className='content'>{detail?.name}</div>
            </div>
            <div className='description-item'>
                <div className='name'>路径</div>
                <div className='content'>{detail?.groups?.map((group, idx) => {
                    return (
                        <>
                            <span>{group.name}</span>
                            {idx < detail?.groups?.length - 1 && (
                                <span>{">>"}</span>
                            )}
                        </>
                    )
                })}</div>
            </div>
            <div className='description-item'>
                <div className='name'>功能</div>
                <div className='content'>{detail?.function}</div>
            </div>
            <div className='description-item'>
                <div className='name'>状态</div>
                <Radio.Group value={detail?.status} size="small">
                    <Radio.Button value="正常">正常</Radio.Button>
                    <Radio.Button value="故障">故障</Radio.Button>
                    <Radio.Button value="维修中">维修中</Radio.Button>
                </Radio.Group>
            </div>

            <div>
                {/* 照片 */}
            </div>
            <div className='detail-tab'>
                <div className={classNames({
                    'tab-item': true,
                    'active': activeTab === ActiveTabType.BASIC
                })} onClick={() => setActiveTab(ActiveTabType.BASIC)}>
                    <div className='name'>基本</div>
                </div>
                <div className={classNames({
                    'tab-item': true,
                    'active': activeTab === ActiveTabType.FILE
                })} onClick={() => {
                    setActiveTab(ActiveTabType.FILE)
                }}>
                    <div className='name'>文件</div>
                </div>
                <div className={classNames({
                    'tab-item': true,
                    'active': activeTab === ActiveTabType.RECORD
                })} onClick={() => {
                    setActiveTab(ActiveTabType.RECORD)
                }}>
                    <div className='name'>维管记录</div>
                </div>
            </div>
            <div className='tab-info'>
                {activeTab === ActiveTabType.BASIC && (
                    <ObjectDetailBasicPanel detail={detail} />
                )}
                {activeTab === ActiveTabType.FILE && (
                    <ObjectDetailFilePanel detail={detail} />
                )}
                {activeTab === ActiveTabType.RECORD && (
                    <ObjectDetailRecordPanel detail={detail} />
                )}
            </div>

        </div>
    )
}
